// Thin wrapper around the analytics IPC bridge. Use this for all new
// instrumentation instead of calling window.electron.analytics directly —
// it guards against missing bridges (web/native shims, tests) and never
// throws into feature code. Event names: snake_case, domain_action shape;
// keep docs/analytics-events.md in sync (npm run check:analytics).

export function track(event, properties = {}) {
    try {
        window.electron?.analytics?.track?.(event, properties);
    } catch {
        // analytics must never break a feature
    }
}

export function resetAnalyticsIdentity() {
    try {
        window.electron?.analytics?.reset?.();
    } catch {
        // ignore
    }
}
